module.exports = __webpack_public_path__ + "img/gasoline-pump.4f67e690.svg";